import * as React from "react";
import { SVGProps, memo } from "react";
const SvgSpacesFilterFiltersNotAppliedDisabled = (
  props: SVGProps<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 18 18"
    xmlSpace="preserve"
    role="img"
    {...props}
  >
    <path
      d="M13.5 3h-10c-1.1 0-1.2 1.2-.6 1.8L7 9v4c0 .5.5 1 1 1h1c.5 0 1-.5 1-1V9l4.1-4.2c.6-.6.5-1.8-.6-1.8zM9 8.5V13H8V8.5L3.6 4h9.8L9 8.5z"
      style={{
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "#bfbfbf",
      }}
    />
  </svg>
);
const Memo = memo(SvgSpacesFilterFiltersNotAppliedDisabled);
export default Memo;
